<template>
    <b-modal :visible="true"
             size="md"
             hide-header
             @hidden="$emit('close')">
        <div class="text-center p-3">
            <font-awesome-icon :icon="icons.faCheckCircle"
                               class="text-success mb-3"
                               size="3x" />
            <h4>{{ showIncassoWarning ? $t('cart.item_added_successfully_incasso') : $t('cart.item_added_successfully') }}</h4>
        </div>
        <template #modal-footer>
            <div class="d-flex justify-content-between w-100">
                <b-button variant="outline-secondary"
                          @click="closeModal">
                    {{ $t('cart.continue_shopping') }}
                </b-button>
                <b-button variant="primary"
                          @click="goToCart">
                    <font-awesome-icon :icon="icons.faShoppingCart"
                                       class="mr-2" />
                    {{ $t('cart.go_to_cart') }}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCheckCircle, faShoppingCart } from '@fortawesome/pro-solid-svg-icons'
import { refreshCartData } from './index'

export default {
  name: 'AddToCartModal',

  components: {
    FontAwesomeIcon
  },

  props: {
    showIncassoWarning: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      icons: {
        faCheckCircle,
        faShoppingCart
      }
    }
  },

  mounted () {
    refreshCartData()
  },

  methods: {
    goToCart () {
      window.location.href = window.cartUrl || '/bestellen/winkelwagen'
    },

    closeModal () {
      // Remove the hash without triggering another hashchange
      history.replaceState(null, '', window.location.pathname + window.location.search)
      this.$emit('close')
    }
  }
}
</script>

<style>
.cart-badge-bounce {
  animation: cartBadgeBounce 0.3s ease-in-out;
}

@keyframes cartBadgeBounce {
  0% {
    transform: scale(0.85);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
  }
}
</style>
